var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-trend-chart"},[_c('div',{ref:"chart",staticClass:"google-trend-chart__canvas"}),(_vm.isEmpty)?_c('div',{staticClass:"google-trend-chart__empty"},[_vm._v("暂无趋势数据")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }